import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserAccountStatus, UserAccountType } from 'src/app/shared/enum';
import { AuthIntegrationService } from 'src/app/shared/services/authentication/auth-integration.service';
import { AuthenticationService } from 'src/app/shared/services/authentication/authentication.service';
import { MsgService } from 'src/app/shared/services/msg.service';
import { LoginLoaderService } from 'src/app/shared/services/common/loader.service';
import { UserViewModel } from 'src/app/shared/models/user';
import { SignupService } from '../service/signup.service';
import { environment } from 'src/environment/environment';
import { error_msg, SignupMethodSessionKey, toastSessionKey } from '../auth-constants';
import { ErrorMsgDict, clearStoredSignupCode } from '../auth-utils';
import { AnalyticsService, isPopup } from '@laasy/common-layout';
import { SegmentEvent } from 'src/app/shared/utilities/constants';
import { VerifyEmailService } from '@laasy/common-layout';
import { RedirectPostLoginService } from '../service/redirect-post-login.service';
@Component({
  selector: 'app-signup-middleware',
  templateUrl: './signup-middleware.component.html',
  styleUrls: ['./signup-middleware.component.scss']
})
export class SignupMiddlewareComponent implements OnInit {
  isConsentGiven: boolean = false;
  isConsentGiven_beta: boolean = false;
  termsAndConditions!: any;
  privacyPolicy!: any;
  betaTerms!: any;
  pdfSource!: string;
  isTermsModalVisible!: boolean;
  isPdfModalVisible: boolean = false;
  agreements: [] = [];
  termsOfUse: any;
  isLoading!: boolean;
  currentUser!: any;
  userInfo: any;
  retryCount:number = 0

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly msgService: MsgService,
    private readonly authIntegrationService: AuthIntegrationService,
    private readonly router: Router,
    private loginLoader: LoginLoaderService,
    private signUpService: SignupService,
    private readonly route: ActivatedRoute,
    private analyticsService: AnalyticsService,
    private verifyEmailService:VerifyEmailService,
    private redirectPostLoginService: RedirectPostLoginService
  ) {}

  async ngOnInit(): Promise<void> {
    this.verifyEmailService.invalidateVerifyEMailCache()
    let userFilledForm:boolean = false
    this.route.queryParams.subscribe(params => {
      if (params['userFilledForm'])
        userFilledForm = true
    })
    this.loginLoader.showLoginLoader(true);
    const user = await this.authenticationService.GetCurrentUser();
    if (user?.username) {
      this.currentUser = user;
      const userEmail = user.attributes?.email ?? user?.signInUserSession?.idToken?.payload?.email;
      const userSubId = user.attributes?.sub ?? user?.signInUserSession?.idToken?.payload?.sub;

      this.currentUser.email = userEmail;
      this.currentUser.sub = userSubId;
      this.verifyEmailService.checkUserByEmail(userEmail).subscribe({
        next: async res => {
          const userCheckResponse = res.data;
          if (userCheckResponse.userExist === true) {
            if (userCheckResponse.accountStatus === UserAccountStatus.Deleted) {
              this.msgService.info(
                `Membership for ${userEmail} is cancelled. Please contact the support team.`
              );
              this.setToastError('Account Cancelled','Account Cancelled',userEmail)
              this.authenticationService.Logout(true);
            } else if (userCheckResponse.accountStatus === UserAccountStatus.Active) {
              const signupMethod = sessionStorage.getItem(SignupMethodSessionKey);
              if(signupMethod){
                this.setToastError('Account Exists','Account Exists PreFilledForm',signupMethod)
                sessionStorage.removeItem(SignupMethodSessionKey);
                this.authenticationService.Logout(false);
              }
              else{
                this.msgService.success('Sign in successful.');
                if(isPopup()){
                  localStorage.setItem('SSO_OAUTH_RESPONSE',"login"+(new Date().toISOString()))
                  window.close()
                }else
                  await this.redirectPostLoginService.redirectPostLogin(userEmail,user)
              }
            }
          }
          else if(environment.idpEnabled){
            if(isPopup()){
              localStorage.setItem('SSO_OAUTH_RESPONSE',"signup"+(new Date().toISOString()))
              window.close()
            }else{
              this.ssoSignupNavigation(userFilledForm,'/auth/single-sign-on');
            }
          }
          else {
            if (!userCheckResponse.isEligible) {
              this.msgService.info(
                'Sorry, the email you entered did not match our records. Please double-check and try again.'
              );
              this.setToastError('Email address not found','Email address not found')
              this.authenticationService.Logout(false);
            }
            else {
              this.ssoSignupNavigation(userFilledForm, '/auth/ssosignup');
            }
            this.loginLoader.showLoginLoader(false);
          }
        },
        error: () => {
          this.msgService.error(
            'Error occurred while signing in. Please try again in a few minutes.'
          );
          this.setToastError('','')
          this.authenticationService.Logout(false);
        }
      });
    }
    else {
      this.analyticsService.segmentTrackEvent( { email: SegmentEvent.ssoUnknownUser, error: user}, SegmentEvent.loginError);
      this.msgService.error('Error occurred while signing up. Please try again in a few minutes.');
      this.setToastError('','')
      setTimeout(() => {
        this.router.navigate(['/auth/signin']);
      }, 2000);
      this.loginLoader.showLoginLoader(false);
      if(isPopup()){
        localStorage.setItem('SSO_OAUTH_RESPONSE',new Date().toISOString())
        window.close()
      }
    }
  }

  setToastError(title:string,errorKey:string,email:string=''){
    if(!sessionStorage.getItem(toastSessionKey))
      sessionStorage.setItem(toastSessionKey,JSON.stringify({
        ...error_msg,
        heading: title,
        text: ErrorMsgDict(email, errorKey)
      }))
  }

  async ssoSignupNavigation(userFilledForm: boolean, route: any){
    this.userInfo = JSON.parse(sessionStorage.getItem('ssoSignupUserInfo') || '{}');
    localStorage.setItem('onboardingFlag',String(true))

    if(userFilledForm || Object.keys(this.userInfo).length !== 0){
      await this.getTerms();
    }else{
      this.loginLoader.showLoginLoader(false);
      this.router.navigate([route], { queryParams: { isLoggedIn: true } });
    }
  }

  addSsoSignupData() {
    this.loginLoader.showLoginLoader(true);
    const signupSourceURL = localStorage.getItem("signupSourceURL")||''
    let userRequest: UserViewModel = {
      userId: this.currentUser?.sub,
      firstName: this.userInfo['fname'],
      lastName: this.userInfo['lname'],
      email: this.currentUser?.email,
      displayName: `${this.userInfo['fname']} ${this.userInfo['lname']}`,
      accountType: UserAccountType.Google,
      termsAgreementId: this.termsAndConditions.agreementId,
      policyAgreementId: this.privacyPolicy.agreementId,
      timeStamp: new Date(),
      phoneNumber: this.userInfo['phone'].replace(/-/g, ''),
      OptInEmailSubscription: this.userInfo['email_opt_in'],
      OptInSmsSubscription: this.userInfo['sms_opt_in'],
      country: this.userInfo['country'],
      zipCode: this.userInfo['zipCode'],
      sourceUrl:signupSourceURL,
      ageRange: this.userInfo?.ageRange,
      gender: this.userInfo?.gender,
      survey:this.userInfo?.survey,
    };
    if(this.signUpService.isSubTenant())
      userRequest = {...userRequest,subTenantId:this.userInfo.subtenant}
    if(this.signUpService.isAuthCodeEnabled())
      userRequest = {...userRequest,authCode:this.userInfo.authCode}

    this.authIntegrationService.addSignupUser(userRequest).subscribe(
      async res => {
        if (res?.isSuccess) {
          const signUpResponse = res.data;
          if (
            signUpResponse.accountStatus == UserAccountStatus.Active ||
            signUpResponse.signUpSuccess
          ) {
            this.msgService.success('Sign in successful.');
            sessionStorage.removeItem("ssoSignupUserInfo")
            localStorage.removeItem("signupSourceURL")
            clearStoredSignupCode()
            await this.redirectPostLoginService.redirectPostLogin(userRequest.email)
            return;
          }
        } else {
          this.msgService.error(
            'Error occurred while signing in. Please try again in a few minutes.'
          );
          this.authenticationService.Logout(false);
        }
      },
      () => {
        this.msgService.error(
          'Error occurred while signing in. Please try again in a few minutes.'
        );
        this.authenticationService.Logout(false);
      }
    );

  }

  async getTerms(): Promise<any> {
   try{
    const response = await this.signUpService.getTerms();
    if(response?.error) throw new Error
    this.termsAndConditions = response?.termsAndConditions;
    this.privacyPolicy = response?.privacyPolicy;
    if (this.termsAndConditions && this.privacyPolicy) {
      this.addSsoSignupData()
    }
    else {
      this.retryCount += 1
      if (this.retryCount < 3) this.getTerms()
      else {
        this.msgService.error(
          'Error occurred while signing up. Please refresh the page and try again later.'
        );
        this.router.navigate(['/']);
      }
    }
   }
   catch(error){
    this.msgService.error(
      'Error occurred while signing up. Please refresh the page and try again later.'
    );
    this.router.navigate(['/']);
   }
  }
}
